import { render, staticRenderFns } from "./rLink.vue?vue&type=template&id=77b3d478&"
import script from "./rLink.vue?vue&type=script&lang=js&"
export * from "./rLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports